import { TableCell } from "@mui/material";
import styles from "../VersionsTableBody/styles.module.css";
import { ActionButton } from "../../VersionAction/ActionButton";
import { RefreshIcon } from "../../../../shared/icons/RefreshIcon";
import type { FC } from "react";
import { usePopover } from "../../../hooks/use-popover";
import { AppPopover } from "../../../AppPopover";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  id: string;
  onOk: (id: string) => void;
}

export const VersionActionCell: FC<Props> = ({ name, id, onOk }) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();

  return (
    <TableCell className={styles["action-cell"]}>
      <ActionButton icon={<RefreshIcon />} onClick={handleOpenPopover} />
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        onClose={handleClosePopover}
        onOk={() => {
          onOk(id);
          handleClosePopover();
        }}
      >
        {t("versioning.restore_popover")}
        <strong>{name}</strong>?
      </AppPopover>
    </TableCell>
  );
};
